// import React, { useRef, useState } from "react";
// import Slider from "react-slick";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// export default function CarImageGallery({ images }) {
//   const [active, setActive] = useState(0);
//   const sliderRef = useRef(null);

//   const NextArrow = ({ onClick }) => (
//     <button
//       onClick={onClick}
//       className="absolute right-2 top-1/2 text-white -translate-y-1/2 bg-transparent rounded-full p-2 shadow z-10 hover:bg-gray-100"
//     >
//       <ChevronRight size={24} />
//     </button>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <button
//       onClick={onClick}
//       className="absolute left-2 top-1/2 text-white -translate-y-1/2 bg-transparent rounded-full  p-2 shadow z-10 hover:bg-gray-100"
//     >
//       <ChevronLeft size={24} />
//     </button>
//   );

//   const sliderSettings = {
//     dots: false,
//     arrows: true,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     beforeChange: (_, newIndex) => setActive(newIndex),
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     adaptiveHeight: true,
//     centerMode: false,
//     variableWidth: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const handleThumbnailClick = (idx) => {
//     setActive(idx);
//     sliderRef.current?.slickGoTo(idx);
//   };

//   return (
//     <div className="flex flex-col gap-4 car-image-gallery">
//       {/* Custom styles to fix slider positioning */}
//       <style>{`
//         .car-image-gallery .slick-slide {
//           display: flex !important;
//           align-items: center !important;
//           justify-content: center !important;
//         }
//         .car-image-gallery .slick-slide img {
//           transform: none !important;
//           max-width: 100% !important;
//           height: auto !important;
//         }
//         .car-image-gallery .slick-track {
//           display: flex !important;
//           align-items: center !important;
//         }
//         .car-image-gallery .slick-list {
//           overflow: hidden;
//         }
//       `}</style>

//       {/* Main Carousel */}
//       <div className=" overflow-hidden shadow aspect-video bg-gray-100 relative">
//         <Slider ref={sliderRef} {...sliderSettings}>
//           {images && images.length > 0 ? (
//             images.map((img, idx) => {
//               // Try different possible image URL properties
//               const imageUrl =
//                 img.imageUrl ||
//                 img.url ||
//                 img.src ||
//                 img.image ||
//                 img.thumbnail ||
//                 img.original;

//               return (
//                 <div className='w-full'>
//                 <div className='w-full shadow-md '>
//                   <div className='relative'>
//                   <img
//                     src={imageUrl}
//                     alt={`Car ${idx + 1}`}
//                     className='aspect-4/3 object-cover w-full'
                    
                    
//                     onError={(e) => {
//                       console.error(`Failed to load image ${idx}:`, imageUrl);
//                       e.target.style.display = "none";
//                     }}
//                   />
//                 </div>
//                 </div>
//                 </div>
               
//               );
//             })
//           ) : (
//             <div className="!flex !items-center !justify-center h-[354px] bg-gray-100">
//               <div className="text-center text-gray-500">
//                 <p>No images available</p>
//               </div>
//             </div>
//           )}
//         </Slider>
//       </div>


//       <div className='grid grid-cols-3 md:grid-cols-6 h-[211px] overflow-y-auto gap-1 mt-4'>
//       {images && images.length > 0 ? (
//           images.map((img, idx) => {
//             // Try different possible image URL properties
//             const imageUrl =
//               img.imageUrl ||
//               img.url ||
//               img.src ||
//               img.image ||
//               img.thumbnail ||
//               img.original;

//             return (
//               <img
//                 key={idx + "thumbview"}
//                 src={imageUrl}
//                 alt={`thumb${idx + 1}`}
//                 className={`h-[100px] w-full object-cover  border-2 cursor-pointer transition-all duration-200 ${
//                   idx === active ? "border-primary-dark" : "border-gray-200"
//                 }`}
//                 onClick={() => handleThumbnailClick(idx)}
//                 onError={(e) => {
//                   console.error(`Failed to load thumbnail ${idx}:`, imageUrl);
//                   e.target.style.display = "none";
//                 }}
//               />
//             );
//           })
//         ) : (
//           <div className="col-span-3 text-center text-gray-500 py-4">
//             <p>No thumbnails available</p>
//           </div>
//         )}
//             </div>

 
//     </div>
//   );
// }









import React, { useState, useMemo, useEffect } from "react";
import placeholder from "../../assets/Car-place-holder-PNG.png";

export default function CarImageGallery({ images, watchingNow = 0, highlight = null }) {
  const [selectedImage, setSelectedImage] = useState(placeholder);

  // Build an array of URL strings from mixed API shapes
  const imageUrls = useMemo(() => {
    if (!images) return [];
    return images
      .map((img) =>
        typeof img === "string"
          ? img
          : img?.imageUrl || img?.url || img?.path || img?.src || ""
      )
      .filter(Boolean);
  }, [images]);

  // Update selected image when new data arrives
  useEffect(() => {
    if (imageUrls.length) setSelectedImage(imageUrls[0]);
    else setSelectedImage(placeholder);
  }, [imageUrls]);

  return (
    <div className='w-full shadow-md max-w-7xl mx-auto'>
      <div className='relative'>
        <img
          src={selectedImage}
          alt='car'
          className={`w-full h-[400px] object-cover ${selectedImage === placeholder ? 'opacity-50' : ''}`}
          onError={(e)=>e.currentTarget.src=placeholder}
        />
        
        {/* Watching Now Badge - Top Right Corner */}
        {watchingNow > 0 && (
          <div className="absolute top-4 right-4 bg-black bg-opacity-70 text-white px-4 py-2 rounded-lg flex items-center gap-2 shadow-lg">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
            <span className="font-semibold text-sm">
              Watching Now: <span className="font-bold">{watchingNow}</span>
            </span>
          </div>
        )}

        {/* Highlight Badge - Bottom Left Corner */}
        {highlight && (
          <div className="absolute bottom-4 left-4 bg-primary text-white px-4 py-2 rounded-lg shadow-lg">
            <span className="font-bold text-sm uppercase tracking-wide">
              {highlight}
            </span>
          </div>
        )}

        {/* Previous Button */}
        {imageUrls.length > 1 && (
          <button
            className='absolute left-2 top-1/2 -translate-y-1/2 bg-transparent rounded-full shadow p-2'
            onClick={() => {
              const idx = imageUrls.indexOf(selectedImage);
              setSelectedImage(
                imageUrls[(idx - 1 + imageUrls.length) % imageUrls.length]
              );
            }}
            aria-label='Previous Image'
          >
            {/* Left Arrow SVG */}
            <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
              <path
                d='M15 6l-6 6 6 6'
                stroke='#ffffff'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
        )}
        {/* Next Button */}
        {imageUrls.length > 1 && (
          <button
            className='absolute right-2 top-1/2 -translate-y-1/2 bg-transparent rounded-full shadow p-2'
            onClick={() => {
              const idx = imageUrls.indexOf(selectedImage);
              setSelectedImage(imageUrls[(idx + 1) % imageUrls.length]);
            }}
            aria-label='Next Image'
          >
            {/* Right Arrow SVG */}
            <svg width='24' height='24' fill='none' viewBox='0 0 24 24'>
              <path
                d='M9 6l6 6-6 6'
                stroke='#ffffff'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
        )}
      </div>
      <div className='grid grid-cols-4 md:grid-cols-6 gap-2 mt-3 max-h-[120px] overflow-y-auto custom-scrollbar'>
        {imageUrls.length > 0 ? (
          imageUrls.map((img, index) => (
            <img
              key={index}
              src={img || placeholder}
              alt={`thumb-${index}`}
              onClick={() => setSelectedImage(img)}
              className={`h-[80px] w-full object-cover cursor-pointer border-2 rounded ${
                selectedImage === img
                  ? "border-primary"
                  : "border-gray-300"
              }`}
              onError={(e)=>e.currentTarget.src=placeholder}
            />
          ))
        ) : (
          <img
            src={placeholder}
            alt='placeholder'
            className='h-[80px]  w-full object-cover border-2 border-gray-300 rounded opacity-50'
          />
        )}
      </div> 
    </div>
  );
}
